import React from 'react';
import { Menu, Layout } from 'antd';
import useMenu from 'src/hooks/useMenu';

const AppMenu: React.FC = () => {
  const { menuItems, getSelectedKey } = useMenu('main');

  return (
    <Layout className={'main-menu'}>
      <div className={'container-lg menu-container'}>
        <div className={'header-menu'}>
          <Menu
            mode="horizontal"
            items={menuItems}
            selectedKeys={getSelectedKey()}
            subMenuCloseDelay={0.2} // fix submenu do not close when hover out
            overflowedIndicator={false}
          />
        </div>
      </div>
    </Layout>
  );
};

export default AppMenu;
